import { Fragment, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import SearchIcon from '../Assets/SvgIcon/SearchIcon';
import { onSetSearch } from '../Store/NavSearch/searchReducer';
import { useGetMovieSelection } from '../hooks/useGetMovieSelection';
import { onCloseMenus } from '../Store/NavHandler/navHandlerReducer';

const NavSearch = () => {
  // =======================
  const navigate = useNavigate();
  const searchRef = useRef(null)
  const { genres } = useSelector((state) => state.navHandlers);

  const dispatch = useDispatch();

  // TMDB v3 returns up to 20 results, limit the displayed suggestions to 4 on the client.
  // TMDB doesn't provide a result limit for this endpoint yet
  const { moviesToDisplay, isLoading, resetSearching, noMovies, searchVal, handleSearch, showSelection, setShowSelection } = useGetMovieSelection()

  const handleEnteringSearch = () => {
    setShowSelection(true)
    dispatch(onCloseMenus());
  }

  const onSubmitSearch = (e) => {
    e.preventDefault();

    dispatch(onSetSearch(searchVal));
    // // route /search
    navigate(`/search?q=${searchVal}&page=1`);
    resetSearching()
  };
  // ==================================

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!searchRef.current?.contains(e.target)) {
        setShowSelection(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowSelection]);

  return (
    <Fragment>
      <div className={showSelection ? "nav-search nav-search-focus": "nav-search"} ref={searchRef}>
        <form className='search-form' onSubmit={onSubmitSearch}>
          <button type='submit'>
            <SearchIcon />
          </button>
          <div className='search-input'>
            <input
              name='name'
              type='text'
              placeholder='Search for a movie...'
              autoComplete='off'
              className='sm-input'
              value={searchVal}
              onChange={handleSearch}
              onFocus={handleEnteringSearch}
            />
            {isLoading && <span className="search-spinner"></span>}
            {searchVal && (
              <button type="button" className="reset-search" onClick={resetSearching}>
                <svg className='exit-icon' data-slot="icon" fill="none" strokeWidth="3.0" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12"></path>
                </svg>
              </button>
            )}
          </div>
        </form>

        {(showSelection) && (
          <div className='selection-container'>
            {moviesToDisplay.length > 0 && (
              <p className='sub-text'>Movies</p>
            )}

            {(noMovies && !!searchVal.length) && (
              <div className='no-movies'>
                <p>No movies found. Try different keywords.</p>
              </div>
            )}
            
            {moviesToDisplay.map((movie) => {
              return <Link onClick={resetSearching} key={movie.id} className="selection" to={`/title/${movie.id}`}>
              <div className='movie'>
                <div className="photo">
                  <img src={`https://image.tmdb.org/t/p/w300${movie.backdrop_path
                  }`} alt={movie.title} />
                </div>
                <div className="details">
                  <div className="title">{movie.title}</div>
                  <div className='sub-detail'>
                    <span className='year'>{new Date(movie.release_date).getFullYear()}</span>
                    <ul className='genres-list'>
                      {movie.genre_ids.slice(0,3).map((genre) => {
                        return (
                          <li key={genre}>
                            <span className="dot">•</span>
                            <span className='genre' key={genre}>{genres.find(item => item.id === genre).name}</span>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                  <div className="rating"><span className="star">★</span> {Number(movie.vote_average.toFixed(1))}</div>
                </div>
              </div>
              <div className='movie-arrow'>
                <svg height={15} width={15} data-slot="icon" fill="none" strokeWidth="3.00" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path>
                </svg>
              </div>
            </Link>
            })}

            {(moviesToDisplay.length === 0 && !noMovies) && (
              <p className='start-typing'>Start typing to discover movies</p>
            )}
            <Link onClick={resetSearching} className='search-for' to={`/search?q=${searchVal}`}>
              <button type='button'>
                <SearchIcon />
              </button>
              <p>Search for {searchVal.length > 0 ? `"${searchVal}"`: "a movie"}</p>
            </Link>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default NavSearch;
